import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from 'helpers/api_helper';

// FETCH Payroll Stop Payment
function* fetchPayrollStopPaymentSaga(action) {
  try {
    const {unit_id} = action.payload;
    const formdata = new FormData();
    formdata.append("unit_id",unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_PAYROLL_STOP_PAYMENT, formdata);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch payroll stop payment!');
    }

    yield put({ type: types.FETCH_PAYROLL_STOP_PAYMENT_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_PAYROLL_STOP_PAYMENT_FAILURE, payload: error.message });
  }
}

// SAVE Payroll Stop Payment
function* savePayrollStopPaymentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_PAYROLL_STOP_PAYMENT, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save payroll stop payment!');
    }

    yield put({ type: types.SAVE_PAYROLL_STOP_PAYMENT_SUCCESS, payload: response.data });
    Swal.fire('Success', response.message || 'Payroll stop payment saved!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_PAYROLL_STOP_PAYMENT_FAILURE, payload: error.message });
  }
}

function* saveReopenPaymentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_REOPEN_PAYMENT, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Reopen Payment!');
    }

    yield put({ type: types.SAVE_REOPEN_PAYMENT_SUCCESS, payload: response.data });
    Swal.fire('Success', response.message || 'Reopen Payment saved!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_REOPEN_PAYMENT_FAILURE, payload: error.message });
  }
}

// Root saga
export default function* payrollStopPaymentSaga() {
  yield takeLatest(types.FETCH_PAYROLL_STOP_PAYMENT_REQUEST, fetchPayrollStopPaymentSaga);
  yield takeLatest(types.SAVE_PAYROLL_STOP_PAYMENT_REQUEST, savePayrollStopPaymentSaga);
  yield takeLatest(types.SAVE_REOPEN_PAYMENT, saveReopenPaymentSaga);
}
